module.exports = __webpack_public_path__ + "assets/img/why.ad6d0411.svg";